module.exports = __webpack_public_path__ + "static/media/verifiedIcon.fda92cde.svg";